import React from 'react';
import { FieldTemplateProps } from '@rjsf/core';
import { Table } from 'semantic-ui-react';

export const TableCellFieldTemplate: React.FC<FieldTemplateProps> = (props: FieldTemplateProps) => {
  console.log('TableCellFieldTemplate props:', props);
  
  return (
    <Table.Cell>{props.children}</Table.Cell>
  );
};
